// extracted by mini-css-extract-plugin
export default {"page":"Terms_page__tkfzi","container":"Terms_container__cd9UM","updated":"Terms_updated__Zl7Vu"};